import { lazyImport } from 'utils/lazyImport';
import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { MainLayout } from 'components';
import { Spin } from 'antd';
import CategoryList from 'screen/Category/categoryList';
import MerchantList from 'screen/merchant/merchantList';
import MerchantVerification from 'screen/merchant/merchantVerification';
import Notifcation from 'screen/Notification/Notification';
import Plan from 'screen/PlanManagement/plan';
import Subscription from 'screen/SubscriptionManagement/subscription';
import CustomersPage from 'screen/Customers/CustomersPage';
import OutletsPage from 'screen/Outlets/OutletsPage';
import CouponsPage from 'screen/Coupons/CouponsPage';
import FeedbackPage from 'screen/Feedback/FeedbackPage';
import SalesRepsPage from 'screen/SalesReps/SalesRepsPage';
import QrManagementPage from 'screen/QrManagement/QrManagementPage';
import TicketsPage from 'screen/Tickets/TicketsPage';

const { Dashboard } = lazyImport(
  () => import('features/dashboard'),
  'Dashboard',
);

const App = () => {
  return (
    <MainLayout>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Spin size="large" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </MainLayout>
  );
};

export const protectedRoutes = [
  {
    path: '/',
    element: <App />,
    children: [
      { path: '/', element: <Dashboard /> },
      { path: '/customers', element: <CustomersPage /> },
      { path: '/merchant', element: <MerchantList /> },
      { path: '/merchantverification', element: <MerchantVerification /> },
      { path: '/outlets', element: <OutletsPage /> },
      { path: '/coupons', element: <CouponsPage /> },
      { path: '/categorylist', element: <CategoryList /> },
      { path: '/feedback', element: <FeedbackPage /> },
      { path: '/notification', element: <Notifcation /> },
      { path: '/plan', element: <Plan /> },
      { path: '/subscription', element: <Subscription /> },
      { path: '/sales-reps', element: <SalesRepsPage /> },
      { path: '/qr-management', element: <QrManagementPage /> },
      { path: '/tickets', element: <TicketsPage /> },
      { path: '*', element: <Navigate to="." /> },
    ],
  },
];
